import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AuthGuard } from './auth.guard';
// Prime-Ng Components
import { FileUploadModule } from 'primeng/fileupload';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { InputMaskModule } from 'primeng/inputmask';
import { EditorModule } from 'primeng/editor';  // uses quill.js
import { ChartModule } from 'primeng/chart'; // uses chart.js
import { CalendarModule } from 'primeng/calendar';
import { AutoCompleteModule } from 'primeng/autocomplete';

// Other External Components
import { ColorPickerModule } from 'ngx-color-picker';


// Dashboard
import { SidebarComponent } from './dashboard/sidebar/sidebar.component';
import { BrandingComponent } from './dashboard/branding/branding.component';
import { InformationComponent } from './dashboard/information/information.component';
import { TestimonialsComponent } from './dashboard/testimonials/testimonials.component';

// Prelogin New
import { PartnerRegistrationComponent } from './prelogin/partner-registration/partner-registration.component';
import { CounsellorRegistrationComponent } from './prelogin/counsellor-registration/counsellor-registration.component';
import { LoginComponent } from './prelogin/login/login.component';
import { ProgressBarComponent } from './dashboard/progress-bar/progress-bar.component';
import { OrganizationDetailsComponent } from './dashboard/organization-details/organization-details.component';
import { MyTeamComponent } from './dashboard/my-team/my-team.component';
import { TeamMemberRolePipe } from './pipes/dashboard/team-member-role.pipe';
// tslint:disable-next-line: max-line-length
import { CounsellorSignupPreprocessingComponent } from './prelogin/counsellor-signup-preprocessing/counsellor-signup-preprocessing.component';
import { ResetPasswordComponent } from './prelogin/reset-password/reset-password.component';

import { MyDashboardComponent } from './dashboard/my-dashboard/my-dashboard.component';
import { AssessmentCouponsComponent } from './dashboard/assessment-coupons/assessment-coupons.component';
import { UpgradeComponent } from './dashboard/upgrade/upgrade.component';
import { PurchaseAssessmentCouponsComponent } from './dashboard/shared/purchase-assessment-coupons/purchase-assessment-coupons.component';
import { BillingInvoiceComponent } from './dashboard/billing-invoice/billing-invoice.component';
import { ForgotPasswordComponent } from './prelogin/forgot-password/forgot-password.component';
import { BillingFrequencyPipe } from './pipes/dashboard/billing-frequency.pipe';
import { StudentProfileComponent } from './dashboard/student-profile/student-profile.component';
import { InfoComponent } from './dashboard/student-profile-partials/info/info.component';
import { TestsComponent } from './dashboard/student-profile-partials/tests/tests.component';
import { MatchesComponent } from './dashboard/student-profile-partials/matches/matches.component';
import { NotesComponent } from './dashboard/student-profile-partials/notes/notes.component';
import { StudentListComponent } from './dashboard/student-list/student-list.component';
import { PlanActionModalsComponent } from './dashboard/shared/plan-action-modals/plan-action-modals.component';
import { OsTestParameterPipe } from './pipes/dashboard/os-test-parameter.pipe';
import { AssessmentTypePipe } from './pipes/dashboard/assessment-type.pipe';
import { IconsModule } from './icons/icons.module';
import { ExamCornerComponent } from './dashboard/exam-corner/exam-corner.component';
import { ExamCornerDetailsComponent } from './dashboard/exam-corner-details/exam-corner-details.component';

import { MyInterceptor } from './auth.interceptor';
import { APP_BASE_HREF } from '@angular/common';
import { PageNotFoundComponent } from './common/page-not-found/page-not-found.component';
import { ScholarshipsComponent } from './dashboard/scholarships/scholarships.component';
import { RoadmapComponent } from './dashboard/roadmap/roadmap.component';
import { PreferencesComponent } from './dashboard/roadmap-partials/preferences/preferences.component';
import { CollegeMapComponent } from './dashboard/roadmap-partials/college-map/college-map.component';
import { ExamShortlistComponent } from './dashboard/roadmap-partials/exam-shortlist/exam-shortlist.component';

@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    BrandingComponent,
    InformationComponent,
    TestimonialsComponent,
    PartnerRegistrationComponent,
    CounsellorRegistrationComponent,
    LoginComponent,
    ProgressBarComponent,
    OrganizationDetailsComponent,
    MyTeamComponent,
    TeamMemberRolePipe,
    CounsellorSignupPreprocessingComponent,
    ResetPasswordComponent,
    MyDashboardComponent,
    AssessmentCouponsComponent,
    UpgradeComponent,
    PurchaseAssessmentCouponsComponent,
    BillingInvoiceComponent,
    ForgotPasswordComponent,
    BillingFrequencyPipe,
    StudentProfileComponent,
    InfoComponent,
    TestsComponent,
    MatchesComponent,
    NotesComponent,
    StudentListComponent,
    PlanActionModalsComponent,
    OsTestParameterPipe,
    AssessmentTypePipe,
    ExamCornerComponent,
    ExamCornerDetailsComponent,
    PageNotFoundComponent,
    ScholarshipsComponent,
    RoadmapComponent,
    PreferencesComponent,
    CollegeMapComponent,
    ExamShortlistComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ColorPickerModule,
    FileUploadModule,
    ProgressSpinnerModule,
    HttpClientModule,
    DropdownModule,
    MultiSelectModule,
    PaginatorModule,
    InputMaskModule,
    EditorModule,
    ChartModule,
    CalendarModule,
    IconsModule,
    AutoCompleteModule
  ],
  providers: [AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: MyInterceptor, multi: true },
    { provide: APP_BASE_HREF, useValue: '/partner' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
